import React, { useEffect } from 'react';
import { osName } from 'react-device-detect';

// Components
import MainLayout from '../components/layouts/MainLayout';
import ContentModelHandler from '../utils/ContentModelHandler';
import SectionWithReferences from '../components/sections/SectionWithReferences';
import SectionWithSideNavigation from '../components/sections/SectionWithSideNavigation';
import Section from '../components/sections/Section';
import PredefinedSection from '../components/sections/PredefinedSection';

// Interfaces
import { Seo as SeoInterface } from '../interfaces/seo';
import { Cookies as CookiesInterface } from '../interfaces/cookies';
import { Menu as MenuInterface } from '../interfaces/menu';
import { Footer as FooterInterface } from '../interfaces/footer';

interface PageProps {
  pageContext: {
    pageId: string;
    locale: string;
    cookies: CookiesInterface;
    seo: SeoInterface;
    menu: MenuInterface;
    footer: FooterInterface;
    data: Array<object>;
    pageNavigation: boolean;
  };
}
const Page = (props: PageProps) => {
  const { pageId, locale, seo, menu, data, cookies, footer, pageNavigation } = props.pageContext;

  const pageStructure: any = data;

  useEffect(() => {
    if (osName === 'Mac OS') {
      document.querySelectorAll<HTMLElement>('.cl-only-for-windows').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll<HTMLElement>('.cl-only-for-mobile').forEach(function (el) {
        el.style.display = 'none';
      });
    } else if (osName === 'Windows') {
      document.querySelectorAll<HTMLElement>('.cl-only-for-mac').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll<HTMLElement>('.cl-only-for-mobile').forEach(function (el) {
        el.style.display = 'none';
      });
    } else {
      document.querySelectorAll<HTMLElement>('.cl-only-for-mac').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll<HTMLElement>('.cl-only-for-windows').forEach(function (el) {
        el.style.display = 'none';
      });
    }
  }, []);

  useEffect(() => {
    document.querySelector<HTMLElement>('.download-link')?.click();
  }, []);

  // Fetches graphQL data from Contentful during development
  if (process.env['NODE_ENV'] === 'development') {
    const fetchContentfulData = (e: any) => {
      e.preventDefault();
      fetch('http://localhost:8000/__refresh', {
        method: 'POST',
      });
    };

    useEffect(() => {
      window.addEventListener('beforeunload', fetchContentfulData);
      return () => {
        window.removeEventListener('beforeunload', fetchContentfulData);
      };
    }, []);
  }

  return (
    <MainLayout
      menu={menu}
      footer={footer}
      cookies={cookies}
      seo={seo}
      pageId={pageId}
      locale={locale}
      pageNavigation={pageNavigation}
    >
      {pageStructure &&
        pageStructure.map((section: any, index: number) => {
          switch (section.sys.contentType.sys.id) {
            case 'pageSection':
              return <Section {...section} key={index} />;
            case 'section':
              return (
                <SectionWithReferences
                  sectionExtraClasses={section.sectionExtraClasses}
                  text={section.text}
                  textExtraClasses={section.textExtraClasses}
                  referenceExtraClasses={section.referenceExtraClasses}
                  key={index}
                >
                  {section.contentModelReferences &&
                    ContentModelHandler(section.contentModelReferences)}
                </SectionWithReferences>
              );
            case 'sectionWithSideNavigation':
              return (
                <SectionWithSideNavigation
                  sideNavigation={section.sideNavigation}
                  sideNavigationExtraClasses={section.sideNavigationExtraClasses}
                  contentToNavigate={section.contentToNavigate}
                  contentExtraClasses={section.contentExtraClasses}
                  key={index}
                />
              );
            case 'predefinedSection':
              return <PredefinedSection {...section} key={index} />;
            default:
              break;
          }
        })}
      {/* Book a demo  */}
      <div className='leadinModal-content'></div>
    </MainLayout>
  );
};

export default Page;
